import {Component, OnInit} from '@angular/core';
import {EmotionService} from '../../../../services/emotion/emotion.service';
import {FaceRecognitionService} from '../../../../services/face-recognition/face-recognition.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['../../../../app.component.scss', './menu.component.scss']
})
export class MenuComponent implements OnInit {
  constructor(public emotionService: EmotionService, public faceRecognitionService: FaceRecognitionService) {
  }

  ngOnInit() {
    /* const canvasPreviewImage = document.getElementById('canvasPreview') as any;
     this.emotionService.setPreview(canvasPreviewImage);*/
  }


  changeOptionSelect() {
    const e = document.getElementById('services') as HTMLSelectElement;
    const selected = e.options[e.selectedIndex].value;

    this.faceRecognitionService.emotionServiceUrl = selected;
    this.emotionService.clearStatistics();
  }

  get CNN_PATH() {
    return FaceRecognitionService.API_CNN;
  }

  get BOVW_PATH() {
    return FaceRecognitionService.API_BOVW;
  }

  get LOCAL_CNN() {
    return FaceRecognitionService.LOCALLY_CNN;
  }
}
